import PatentsPage from './PatentsPage';
export default PatentsPage;
